/**
 * downloads a csv file based on data array
 * example data: [
    ['Name', 'Age'],
    ['John Doe', '30'],
    ['Jane Doe', '25'],
  ];
 * @param {*} data data to convert
 * @param {string} filename name of csv file, without ".csv"
 */
export default function exportToCsv(data, filename="data") {
  // Convert data to CSV string
  const csvContent = data.map(row => row.join(',')).join('\n');

  // Create a Blob with the CSV content and the appropriate MIME type
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Create a temporary anchor element and trigger the download
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};